export const SELECT_DELIVERY_ADDRESS = 'SELECT_DELIVERY_ADDRESS';
export const SELECT_BILLING_ADDRESS = 'SELECT_BILLING_ADDRESS';
export const ADD_DELIVERY_ADDRESS = 'ADD_DELIVERY_ADDRESS';
export const ADD_PAYMENT = 'ADD_PAYMENT';
export const SELECT_PAYMENT = 'SELECT_PAYMENT';
export const CONFIRM_PAYMENT = 'CONFIRM_PAYMENT';
export const ADD_BILLING_ADDRESS = 'ADD_BILLING_ADDRESS';
export const CONFIRM_LEAVE = 'CONFIRM_LEAVE';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const EDIT_DELIVERY_DETAILS = 'EDIT_DELIVERY_DETAILS';
export const EDIT_PAYMENT = 'EDIT_PAYMENT';

// flows

export const CHANGE_HOW_YOU_PAY = 'CHANGE_HOW_YOU_PAY';
export const SETUP_HOW_YOU_PAY = 'SETUP_HOW_YOU_PAY';
export const INITIAL_ENROLLMENT = 'INITIAL_ENROLLMENT';
export const CHANGE_WHERE_YOU_GET_IT = 'CHANGE_WHERE_YOU_GET_IT';
export const SETUP_WHERE_YOU_GET_IT = 'SETUP_WHERE_YOU_GET_IT';
export const EDIT_CARD_DETAILS = 'EDIT_CARD_DETAILS';
export const RE_ENROLL = 'RE_ENROLL';
